import React from "react";

import { CreditCard as CheckoutIcon } from "mdi-material-ui";

const Icon = () => <CheckoutIcon />;

const Title = () => <span>Checkout</span>;

const Event = { Icon, Title };

export default Event;
